import React, { Component, useState, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { AutoSizer, List } from "react-virtualized";
import _ from "lodash";
import Moment from "moment";
import { Messages, MessageNotif, DirectboxReceive } from "iconsax-reactjs";

import {
  addAtendimento,
  AlterScreen,
  ShowVisibleNextAtd,
  ShowInfoDisplay,
  clearConferenceExt,
  createStatusAgent,
  addInteractionIngDesk,
  clearQtdMsg,
  GetAnotations,
  GetFileShared,
  GetHistory,
  GetInteractionsContact,
  GetMarkstar,
  InteracoesContactNumberPeer,
  UpdateRgBlockReturn,
  changeNextCallQueueTab,
  changeWaitingCallQueueTab,
  changeChatCallQueueTab,
} from "../../actions";
import { ChangeAtendimento, SendReadingMsg } from "../../actions/websocket";
import { PopoverNotifier, Tooltippy } from "../../actions/Tippy";

import { connection_platform } from "../../services/api";

import { getIconByChannel } from "../../utils/getIconByChannel";

import UserPhoto from "../../components/UserPhoto/userphoto";
import QueueTab from "../../components/QueueTab";
import Drawer from "../../components/manager-section/DrawerSlim/DrawerSlim";

import { ReactComponent as Arrow } from "../../build/images/arrow-left.svg";

// import "../../build/css/queue-new.css";
import "./queue-slim-new.css";
import QueueNew from "../QueueNew/QueueNew";

const { meses } = require("../../services/data");

var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

const QueueSlimNew = ({ pathfile }) => {
  const dispatch = useDispatch();

  const DisplayNextAtd = useSelector((state) => state.displaynextatd);
  const InfoDisplay = useSelector((state) => state.infodisplay);
  const TabChatInfo = useSelector(
    (state) => state.queueTabActive.isTabChatInfoActive,
  );
  const atdSimult = useSelector((state) => state.atdsimult);
  const contactId = useSelector((state) => state.atendimento);
  const infoUsers = useSelector((state) => state.informationusers);
  // const infoUsers = useSelector(
  //   (state) => state.informationusers,
  //   (prev, next) => _.isEqual(prev) === _.isEqual(next)
  // );
  const IPCurrent = useSelector((state) => state.ipcurrent);
  const statusAgent = useSelector((state) => state.status);
  const serviceURL = useSelector((state) => state.serviceurl);
  const connectionsAPI = useSelector((state) => state.connectionsapi);
  const messages = useSelector((state) => state.messages);
  const listCallQueue = useSelector((state) => state.listcallqueue);
  const Filters = useSelector((state) => state.filters);
  const queueTabActive = useSelector((state) => state.queueTabActive);

  const [visible, setVisible] = useState(" active");
  const [equipesVisible, setEquipesVisible] = useState(false);
  const [clientesVisible, setClientesVisible] = useState(false);
  const [atdArray, setAtdArray] = useState([]);
  const [tabChatsInfo, setTabChatsInfo] = useState({
    id: "chats",
    title: "Conversas",
    qtdMessages: 0,
    isActive: false,
    icon: <Messages variant="Outline" />,
  });
  const [tabNextCallInfo, setTabNextCallInfo] = useState({
    id: "nextCall",
    title: "Próx. Atend.",
    qtdMessages: 0,
    isActive: false,
    icon: <MessageNotif variant="Outline" />,
  });
  const [tabWaitingInfo, setTabWaitingInfo] = useState({
    id: "waiting",
    title: "Standby",
    qtdMessages: 0,
    isActive: false,
    icon: <DirectboxReceive variant="Outline" />,
  });
  const [totalMsgsChats, setTotalMsgsChats] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [changeTypeQueue, setChangeTypeQueue] = useState("");

  const ShowVisible = () => {
    dispatch(ShowVisibleNextAtd(true, true));
    setOpenDrawer(false);
    setTabWaitingInfo((prevState) => ({
      ...prevState,
      isActive: false,
    }));
    setTabNextCallInfo((prevState) => ({
      ...prevState,
      isActive: false,
    }));
    setTabChatsInfo((prevState) => ({
      ...prevState,
      isActive: false,
    }));
  };

  const changeAtdSimult = (
    infouser,
    atendimento,
    atdsimultaneo,
    ipcurrent,
    status,
  ) => {
    //
    dispatch(
      addAtendimento(
        atendimento.idatendimento,
        atendimento.cliente,
        atendimento.telefone,
        atendimento.servico,
        atendimento.datatimeatd,
        atendimento.criticidade,
        atendimento.menubot,
        atendimento.subservico,
        atendimento.serviceatd,
        atendimento.recuperation,
        atendimento.time,
        atendimento.direction,
        atendimento.idmidia,
        atendimento.timecomplete,
        atendimento.statusagent,
        atendimento.line,
        atendimento.queueid,
        atendimento.serverid,
        atendimento.qtdmessage,
        atendimento.pathfile,
        atendimento.mcdu,
        atendimento.nomesubservico,
        atendimento.infoinitcall,
        atendimento.nomecliente,
        atendimento.protocolo,
        atendimento.idsubservico,
        atendimento.acw,
        atendimento.isDialNc2,
        atendimento.arrayChannels,
        atendimento.caseId,
        atendimento.statusatd,
        atendimento.score_class,
        atendimento.score_value,
        atendimento.nps_call,
        atendimento.isTabulation,
      ),
      InteracoesContactNumberPeer(atendimento.telefone, infouser.idgroup),
      UpdateRgBlockReturn(infouser, status),
      ChangeAtendimento(
        infouser,
        atendimento,
        atdsimultaneo,
        ipcurrent,
        status,
      ),
      clearQtdMsg(atdsimultaneo.idatendimento),
    );
    SendReadingMsg(atendimento, infouser);

    dispatch(clearQtdMsg(atendimento.idatendimento));
    dispatch(GetHistory([]));
    dispatch(GetInteractionsContact([]));
    dispatch(GetMarkstar([]));
    dispatch(GetFileShared([]));
    dispatch(GetAnotations([]));
  };

  const alterStatus = (data, reason) => {
    dispatch(
      createStatusAgent(data, reason, Moment().format("DD/MM/YYYY HH:mm:ss")),
    );
  };

  const sendInfoInteractionIngDesk = (ContactId) => {
    let url_iframe = "";

    if (serviceURL.length !== 0) {
      let ArrayServiceURL = "";
      if (infoUsers.nameauth === "IngDesk") {
        ArrayServiceURL = serviceURL.filter(
          (url) => url.typeofcrm === "IngDesk",
        );
        if (ArrayServiceURL.length !== 0) {
          url_iframe = ArrayServiceURL[0].param;
        }
      }
    }

    // url_iframe = "http://localhost:3000";
    if (url_iframe !== "") {
      let channel = "0";

      if (parseInt(ContactId.idmidia) === 1) channel = "Voz";
      else if (parseInt(ContactId.idmidia) === 5) channel = "Whatsapp";
      else if (parseInt(ContactId.idmidia) === 8) channel = "Telegram";

      let jsonIngDesk = {
        origin: "ingweb",
        id: "currentInteraction",
        payload: {
          clientId: null,
          clientName: ContactId.cliente,
          channelId: ContactId.idmidia,
          channelName: channel,
          destination: ContactId.telefone,
          protocol: ContactId.protocolo,
        },
      };
      connectionsAPI.iframe_ref.current.contentWindow.postMessage(
        jsonIngDesk,
        url_iframe,
      );
      // this.props.addIteractionIngDesk(jsonIngDesk.payload);
      dispatch(addInteractionIngDesk(jsonIngDesk.payload));
      connectionsAPI.iframe_ref.current.contentWindow.postMessage(
        {
          origin: "ingweb",
          id: "getContactIdInteraction",
          telefone: ContactId.telefone,
        },
        url_iframe,
      );
    }

    // this.setState({ activeCrm: true }); VÊ ISSO AQ
  };

  const changeAtd = (
    infouser,
    atendimento,
    atdsimultaneo,
    ipcurrent,
    status,
  ) => {
    let atendimentoid = atendimento.idatendimento;
    // mensagensnaolidas[atendimento.idatendimento] = false;
    let contactid = contactId;
    let textMessage = [];

    let nov = [];

    if (InfoDisplay.infodisplay !== "Clientes") {
      dispatch(ShowInfoDisplay("Clientes"));
      dispatch(AlterScreen("Clientes"));
    }

    // this.props.clearConference(atendimento);
    dispatch(clearConferenceExt(atendimento));

    // if (!this.state.mute) {
    //   nov[contactid.idatendimento] = this.state.mute;
    // }
    // if (!this.state.pause) {
    //   nov[contactid.idatendimento] = this.state.mute;
    // }

    changeAtdSimult(infouser, atendimento, atdsimultaneo, ipcurrent, status);

    if (atendimento.direction == "2" && atendimento.line == "0") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Atendimento", "S.(" + atendimento.telefone + ")");
    } else if (atendimento.direction == "1" && atendimento.line == "0") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Atendimento", "E.(" + atendimento.telefone + ")");
    } else if (atendimento.line != "0" && atendimento.direction == "2") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Ligação", "S.(" + atendimento.telefone + ")");
    } else if (atendimento.line != "0" && atendimento.direction == "1") {
      if (atendimento.acw === true)
        alterStatus("Aftercallwork", "S.(" + atendimento.telefone + ")");
      else alterStatus("Ligação", "E.(" + atendimento.telefone + ")");
    }

    // this.setState({ buttonMore: false });
    sendInfoInteractionIngDesk(atendimento);

    setTimeout(() => {
      if (textMessage[atendimento.idatendimento] !== undefined) {
        document.getElementById("chat-message").innerText =
          textMessage[atendimento.idatendimento];
      } else {
        document.getElementById("chat-message").innerText = "";
      }
      // this.setState({ editableQuickAnswer: false });
      document.getElementById("chat-message").contentEditable = true;
    }, 200);
  };

  const handleDrawerOpen = (field) => {
    let fieldInfo = tabChatsInfo;
    let activeInfos = { nextCall: false, waiting: false, chats: false };
    let newValueDrawer = false;
    if (field === "nextCall") {
      const isAlreadyActive = tabNextCallInfo.isActive;
      if (!isAlreadyActive) {
        activeInfos = { ...activeInfos, nextCall: true };
        newValueDrawer = true;
      }
      fieldInfo = tabNextCallInfo;
    } else if (field === "waiting") {
      const isAlreadyActive = tabWaitingInfo.isActive;
      if (!isAlreadyActive) {
        activeInfos = { ...activeInfos, waiting: true };
        newValueDrawer = true;
      }
      fieldInfo = tabWaitingInfo;
    }
    setTabWaitingInfo((prevState) => ({
      ...prevState,
      isActive: activeInfos.waiting,
    }));
    setTabNextCallInfo((prevState) => ({
      ...prevState,
      isActive: activeInfos.nextCall,
    }));
    setTabChatsInfo((prevState) => ({
      ...prevState,
      isActive: activeInfos.chats,
    }));
    setChangeTypeQueue(field);

    setOpenDrawer(newValueDrawer);
  };

  const getFormattedLastInteractionDate = (call, messages) => {
    let lastDate = call.datatimeatd;
    let destinomsg = null;

    if (messages[call.idatendimento]) {
      const lastMsg = messages[call.idatendimento].at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDate = lastMsg.dataenvio;
        destinomsg = lastMsg.destiny;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDate = dateString;
            }
          }
        }
      }
    }

    const dateObj = Moment(lastDate, "DD/MM/YYYY HH:mm:ss");
    const now = Moment();

    // const diffDays = now.diff(dateObj, "days");
    const isToday = now.isSame(dateObj, "day");
    // const isYesterday = diffDays === 1;
    const isYesterday = now.clone().subtract(1, "day").isSame(dateObj, "day");

    if (isToday) {
      return { formatted: dateObj.format("HH:mm"), destinomsg };
    }

    if (isYesterday && destinomsg !== "Me") {
      return { formatted: "Ontem", destinomsg };
    }

    return { formatted: dateObj.format("DD/MM/YYYY"), destinomsg };
  };

  const handleSortAtd = (a, b) => {
    let lastDateA = a.datatimeatd;
    let lastDateB = b.datatimeatd;

    if (messages[a.idatendimento]) {
      const lastMsg = messages[a.idatendimento].at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDateA = lastMsg.dataenvio;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDateA = dateString;
            }
          }
        }
      }
    }

    if (messages[b.idatendimento]) {
      const lastMsg = messages[b.idatendimento].at(-1);
      const hasData = !!lastMsg.dataenvio && lastMsg.dataenvio !== "undefined";

      if (hasData) {
        lastDateB = lastMsg.dataenvio;
      } else {
        const { dia, anoenvio, datatime } = lastMsg || {};
        if (dia && anoenvio && datatime) {
          const arrDia = dia.split(" ");
          if (Array.isArray(arrDia) && arrDia.length >= 3) {
            const day = arrDia[0];
            const monthIndex = meses.indexOf(arrDia[2].toLowerCase());

            if (monthIndex >= 0 && monthIndex < 12) {
              const month = String(monthIndex + 1).padStart(2, "0");
              const dateString = `${day}/${month}/${anoenvio} ${datatime}`;
              lastDateB = dateString;
            }
          }
        }
      }
    }

    const dateObjA = Moment(lastDateA, "DD/MM/YYYY HH:mm:ss");
    const dateObjB = Moment(lastDateB, "DD/MM/YYYY HH:mm:ss");

    // return dateObjA - dateObjB;
    return dateObjB - dateObjA;
  };

  const renderProfilePicture = (
    key,
    style,
    idmidia,
    lastInteractionDate,
    call,
  ) => {
    return (
      <div
        className={`queue-atend--slim__chats-chat ${
          call.idatendimento === contactId.idatendimento ? "active" : ""
        }`}
        key={key}
        style={{ ...style, height: 54, width: "100%" }}
        onClick={() =>
          changeAtd(infoUsers, call, atdSimult, IPCurrent, statusAgent)
        }
      >
        <Tooltippy
          content={
            <div className="preview-infos">
              <span>{createJSON(call.cliente)}</span>
              <span>{lastInteractionDate}</span>
            </div>
          }
          placement="right"
        >
          <div style={{ position: "relative", height: "100%", width: "100%" }}>
            {call.qtdmessage > 0 && (
              <span className={`badge`}>{call.qtdmessage}</span>
            )}
            {Boolean(call) &&
              Boolean(call.cliente) &&
              typeof call.cliente === "string" && (
                <UserPhoto
                  size="large"
                  letterIcon={createJSON(call.cliente.trim())}
                />
              )}
            <div className="queue-atend--slim__chats-chat__media">
              {getIconByChannel(idmidia)}
            </div>
          </div>
        </Tooltippy>
      </div>
    );
  };

  useEffect(() => {
    if (Object.keys(DisplayNextAtd).length !== 0) {
      if (
        DisplayNextAtd.displaynextatd === true ||
        (DisplayNextAtd.displaynextatd === "ocultar" &&
          InfoDisplay.infodisplay === "Equipes")
      ) {
        setVisible("");
      } else if (DisplayNextAtd.displaynextatd === false) {
        setVisible(" active");
      } else {
        setVisible(" active");
      }
    }
  }, [DisplayNextAtd, InfoDisplay]);

  useEffect(() => {
    if (atdSimult.length > 0 && infoUsers.loginresponse) {
      let filterAtd = [...atdSimult];
      const getOrder = localStorage.getItem("filterOrder")
        ? localStorage.getItem("filterOrder")
        : "order";
      if (getOrder === "message") {
        filterAtd = filterAtd.sort(handleSortAtd);
      }

      const filterMsgs = filterAtd.filter(
        (atd) => atd.idatendimento !== contactId.idatendimento,
      );
      let msgsChats = 0;
      filterMsgs.forEach((atd) => {
        msgsChats = msgsChats + parseInt(atd.qtdmessage);
      });

      setTotalMsgsChats(msgsChats);
      setAtdArray(filterAtd);
    } else {
      setAtdArray([]);
    }
  }, [atdSimult, contactId, messages, infoUsers, visible]);

  return (
    <div
      className={`queue-atend--slim w-5 ${visible} ${
        atdArray.length > 0 ? "mx-width" : "mn-width"
      } ${openDrawer ? "change-border" : ""}`}
      // onClick={atdArray.length === 0 && !openDrawer ? ShowVisible : null}
    >
      <div className="queue-atend--slim__icon" onClick={ShowVisible}>
        <Tooltippy content={"Exibir"}>
          <Arrow />
        </Tooltippy>
      </div>
      <div className="queue-atend--slim__tabs">
        <div className="queue-atend--slim__tab">
          <QueueTab
            tabInfo={tabNextCallInfo}
            qtdClients={queueTabActive.queueLength}
            onClick={(e) => {
              e.stopPropagation();
              handleDrawerOpen("nextCall");
            }}
            iconUse={true}
          />
        </div>
        {infoUsers.standby_permission && (
          <div className="queue-atend--slim__tab">
            <QueueTab
              tabInfo={tabWaitingInfo}
              qtdClients={queueTabActive.standbyLength}
              qtdMessages={queueTabActive.msgsStandby}
              onClick={(e) => {
                e.stopPropagation();
                handleDrawerOpen("waiting");
              }}
              iconUse={true}
            />
          </div>
        )}
        <div className="queue-atend--slim__tab no-bottom-border">
          <QueueTab
            tabInfo={tabChatsInfo}
            qtdClients={atdSimult.length}
            qtdMessages={totalMsgsChats}
            onClick={(e) => {
              e.stopPropagation();
              handleDrawerOpen("chats");
            }}
            iconUse={true}
          />
        </div>
      </div>

      {atdArray.length > 0 ? (
        <div className="queue-atend--slim__chats">
          <AutoSizer>
            {({ width, height }) => {
              const cellHeight = 64;
              const newHeight = Math.max(atdArray.length * 64, 500);
              const rowRendered = ({ key, index, style }) => {
                const call = atdArray[index];
                const { formatted: lastInteractionDate } =
                  getFormattedLastInteractionDate(call, messages);
                return renderProfilePicture(
                  key,
                  style,
                  call.idmidia,
                  lastInteractionDate,
                  call,
                );
              };
              return (
                <List
                  width={width}
                  height={height}
                  rowCount={atdArray.length}
                  rowHeight={cellHeight}
                  rowRenderer={rowRendered}
                />
              );
            }}
          </AutoSizer>
        </div>
      ) : (
        ""
      )}

      <Drawer
        className="queue-slim"
        isOpen={openDrawer}
        title="Próximos atendimentos"
        typeScreen={changeTypeQueue}
      ></Drawer>
    </div>
  );
};

export default QueueSlimNew;

//OLD VERSION
// const mapStateToProps = (state) => {
//   return {
//     DisplayNextAtd: state.displaynextatd,
//     InfoDisplay: state.infodisplay,
//   };
// };

// const mapDispatchToProps = (dispatch) => ({
//   ShowVisibleNextAtdIn: (post, temp) => {
//     dispatch(ShowVisibleNextAtd(post, temp));
//   },
// });

// class QueueSlimNew extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       visible: " active",
//       equipesVisible: false,
//       clientesVisible: false,
//     };
//   }

//   ShowVisible() {
//     this.props.ShowVisibleNextAtdIn(true, true);
//   }

//   render() {
//     const { DisplayNextAtd, InfoDisplay } = this.props;

//     if (DisplayNextAtd.length != 0) {
//       if (
//         DisplayNextAtd.displaynextatd === true ||
//         DisplayNextAtd.displaynextatd === "ocultar"
//       ) {
//         this.state.visible = "";
//       } else if (DisplayNextAtd.displaynextatd === false) {
//         this.state.visible = " active";
//       } else {
//         this.state.visible = " active";
//       }
//     }

//     return (
//       <div
//         className={"prox-atend--slim w-5" + this.state.visible}
//         onClick={(event) => this.ShowVisible(event)}
//       >
//         <span className="prox-atend--slim__tool-tip tool-tip">Exibir</span>
//         <Arrow className="prox-atend--slim__icon" />

//         <p className="prox-atend--slim__text">Próximos atendimentos</p>
//       </div>
//     );
//   }
// }

// export default connect(mapStateToProps, mapDispatchToProps)(QueueSlimNew);
